const ERROR_REQUIRED = 'This field is required.';

export type ChampionConsentFormValues = {
  name: string;
  email: string;
  /** Champions Program Agreement — matches `UnifiedChampionConsentInput.consentProgramAgreement` */
  consentProgramAgreement: boolean;
  /** Atlassian Privacy Policy — matches `UnifiedChampionConsentInput.consentPrivacyPolicy` */
  consentPrivacyPolicy: boolean;
  /** NDA — matches `UnifiedChampionConsentInput.consentNda` */
  consentNda: boolean;
  /** Success Champion Agreement — matches `UnifiedChampionConsentInput.consentSuccessChampionAgreement` */
  consentSuccessChampionAgreement: boolean;
};

export type ChampionConsentFormErrors = Partial<Record<keyof ChampionConsentFormValues, string>>;

export type ChampionConsentFormValidationOptions = {
  accountIsManaged: boolean;
};

export const validateChampionConsentForm = (
  values: ChampionConsentFormValues,
  options: ChampionConsentFormValidationOptions,
): ChampionConsentFormErrors => {
  const errors: ChampionConsentFormErrors = {};

  if (!values.consentProgramAgreement) {
    errors.consentProgramAgreement = ERROR_REQUIRED;
  }

  if (!values.consentPrivacyPolicy) {
    errors.consentPrivacyPolicy = ERROR_REQUIRED;
  }

  if (!values.consentNda) {
    errors.consentNda = ERROR_REQUIRED;
  }

  if (options.accountIsManaged && !values.consentSuccessChampionAgreement) {
    errors.consentSuccessChampionAgreement = ERROR_REQUIRED;
  }

  return errors;
};
